import { Box } from "@mui/material";


const PasswordBox = ({ children }) => {
  return (
    <Box
      sx={{
        width: "400px",
        border: "solid 1px #2a9941",
        padding: "20px",
        borderRadius: "10px",
      }}
    >
      {children}
    </Box>
  );
};

export default PasswordBox;
